import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merges class names, letting a later Tailwind utility win over an earlier one
 * in the same group.
 *
 * Without `twMerge`, `cn("p-2", "p-4")` emits both and the result depends on
 * stylesheet order — which is how a `className` prop silently fails to override
 * a component's default.
 */
export function cn(...inputs: ClassValue[]): string {
	return twMerge(clsx(inputs));
}
